import { Link, useNavigate } from "react-router-dom";

import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import DatafeedGrid from "../../components/datafeedGrid";

import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";

export default function ProductHomeWeatherForecasts() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [])

    const navigate = useNavigate();

    const handleCreateDataConnection = () => {
        navigate("/contentsources");
    }

    return <div>
            <CcTitle>
                Weather Forecasts
            </CcTitle>
            <Link to={`/workflow/18`} style={linkStyle}> 
                <CcCreateNewSnippet className="mt-4" >Create new Weather Forecasts Image</CcCreateNewSnippet>
            </Link>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                <div>
                <TemplateGallery productTypeId={18} />
                </div>
            </div>

            <CcSubSectionTitle className="mt-6">Latest Weather Forecasts Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={18}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}